import { Component } from '@angular/core';

@Component({
    selector: 'kh-inline-notification-error',
    templateUrl: './inline-notification-error.component.html',
    styleUrls: ['./inline-notification-error.component.scss']
})
export class InlineNotificationErrorComponent {
}
